export default "__VITE_ASSET__BiwYSYlS__"